import type { ReactNode } from "react";
import { Badge, vars } from "@pack-it-up/ui-web";
import type { SyncEntry, SyncEntryStatus } from "@pack-it-up/core";
import type { BadgeTone } from "@pack-it-up/ui-web";

// Doc 13 §2/§3 — how a row relates to the selected template, as a pill on the row.
// `conflict` is the only one that needs attention, so it takes the `warn` tone
// (the design system's alert hue, softened) rather than another amber.
const LABELS: Record<SyncEntryStatus, string> = {
  unchanged: "Unchanged",
  edited: "Edited",
  conflict: "Changed in template",
  new: "New",
  templateOnly: "Only in template",
};

const TONES: Record<SyncEntryStatus, BadgeTone> = {
  unchanged: "neutral",
  edited: "accent",
  conflict: "warn",
  new: "accentSoft",
  templateOnly: "neutral",
};

// The row's sync status pill plus, when the row's assignment can't travel back
// (Doc 13 §4.1), a quiet note so the omission is visible rather than mysterious.
export const SyncStatusBadge = ({ entry }: { entry: SyncEntry }): ReactNode => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: vars.space.xs }}>
    {entry.assignmentSkipped && (
      <span style={{ fontSize: vars.font.size2xs, color: vars.color.textMuted, fontStyle: "italic" }}>
        assignment not synced
      </span>
    )}
    <Badge tone={TONES[entry.status]}>{LABELS[entry.status]}</Badge>
  </span>
);
